"use client";

import React, { useEffect, useState } from "react";
import { parseCookies, setCookie } from "nookies";
import { BR, US, ES } from "country-flag-icons/react/3x2";

const COOKIE_NAME = "googtrans";

interface LanguageDescriptor {
  name: string;
  title: string;
}

const getFlagIcon = (lang: string) => {
  const iconProps = { className: "w-6 h-6 inline-block" };
  switch (lang) {
    case "pt-br":
      return <BR title="Português" {...iconProps} />;
    case "en":
      return <US title="English" {...iconProps} />;
    case "es":
      return <ES title="Español" {...iconProps} />;
    default:
      return null;
  }
};

const LanguageSwitcher = () => {
  const [currentLanguage, setCurrentLanguage] = useState<string>();
  const [languageConfig, setLanguageConfig] = useState<{
    languages: LanguageDescriptor[];
    defaultLanguage: string;
  } | null>(null);

  useEffect(() => {
    const cookies = parseCookies();
    const cookieValue = cookies[COOKIE_NAME]?.split("/")[2];

    const config = globalThis.__GOOGLE_TRANSLATION_CONFIG__;
    const lang = cookieValue || config?.defaultLanguage;

    if (lang) setCurrentLanguage(lang);
    if (config) setLanguageConfig(config);
  }, []);

  if (!currentLanguage || !languageConfig) return null;

  const switchLanguage = (lang: string) => () => {
    setCookie(null, COOKIE_NAME, `/auto/${lang}`);
    window.location.reload();
  };

  return (
    <div className="space-x-2 notranslate">
      {languageConfig.languages.map(({ name }, i) => {
        const isActive =
          currentLanguage === name ||
          (currentLanguage === "auto" && languageConfig.defaultLanguage === name);

        return isActive ? (
          <span key={i} className="opacity-70">
            {getFlagIcon(name)}
          </span>
        ) : (
          <a
            key={i}
            onClick={switchLanguage(name)}
            className="text-blue-300 cursor-pointer hover:underline"
          >
            {getFlagIcon(name)}
          </a>
        );
      })}
    </div>
  );
};

export { LanguageSwitcher, COOKIE_NAME };